<template>
  <div>
    <div v-if="localCards.length" class="ap-contact-cards">
      <div
        v-for="(card, idx) in localCards"
        :key="idx"
        class="ap-contact-card"
        :class="{ 'ap-contact-card--error': cardErrors[idx] && Object.values(cardErrors[idx]).some(Boolean) }"
      >
        <div class="ap-contact-card-top">
          <select-input
            v-model="card.label"
            label="Category"
            :options="labelOptions"
            :required="!!(cardErrors[idx] && cardErrors[idx].label)"
            placeholder="Select category…"
            style="margin-bottom:0"
          />
          <button
            v-if="localCards.length > minCards"
            class="ap-contact-card-remove"
            type="button"
            title="Remove"
            @click="removeCard(idx)"
          >
            <fa-icon :icon="['fas', 'times']" />
          </button>
        </div>
        <select-input
          v-model="card.title"
          label="Title"
          :options="titleOptions"
          placeholder="Select title…"
          style="margin-bottom:0"
        />
        <text-input
          v-model="card.name"
          label="Full Name"
          :icon="['fas', 'user']"
          :required="!!(cardErrors[idx] && cardErrors[idx].name)"
          :uppercase="true"
          placeholder="Full name"
          style="margin-bottom:0"
        />
        <phone-input
          v-model="card.phone"
          label="Phone"
          :required="!!(cardErrors[idx] && cardErrors[idx].phone)"
          style="margin-bottom:0"
        />
        <email-input
          v-model="card.email"
          label="Email"
          :required="!!(cardErrors[idx] && cardErrors[idx].email)"
          placeholder="email@example.com"
          style="margin-bottom:0"
        />
        <div class="ap-field" style="margin-bottom:0">
          <label>Email Group <span v-if="cardErrors[idx] && cardErrors[idx].emailGroup" class="ap-req">*</span></label>
          <div class="ap-contact-roles">
            <label
              v-for="role in ROLES"
              :key="role"
              class="ap-contact-role"
              :class="{ 'is-active': card.roles.includes(role) }"
            >
              <input
                type="checkbox"
                :checked="card.roles.includes(role)"
                style="display:none"
                @change="toggleRole(idx, role)"
              />
              {{ role.toUpperCase() }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="ap-contact-add-wrapper">
      <button class="ap-contact-add-btn" type="button" @click="addCard">
        <fa-icon :icon="['fas', 'plus']" /> Add Contact
      </button>
    </div>
  </div>
</template>

<script>
import SelectInput from '@/components/form/SelectInput.vue'
import TextInput from '@/components/form/TextInput.vue'
import PhoneInput from '@/components/form/PhoneInput.vue'
import EmailInput from '@/components/form/EmailInput.vue'

const LABEL_OPTIONS = [
  { value: 'Internal Staff', label: 'Internal Staff' },
  { value: 'Outsourced Account', label: 'Outsourced Account' },
  { value: 'Director', label: 'Director' },
  { value: 'Shareholder', label: 'Shareholder' }
]

const TITLE_OPTIONS = [
  { value: 'Mr.', label: 'Mr.' },
  { value: 'Mrs.', label: 'Mrs.' },
  { value: 'Ms.', label: 'Ms.' },
  { value: 'Dr.', label: 'Dr.' },
  { value: 'Prof.', label: 'Prof.' },
  { value: "Dato'", label: "Dato'" },
  { value: 'Datin', label: 'Datin' },
  { value: 'Tan Sri', label: 'Tan Sri' },
  { value: 'Puan Sri', label: 'Puan Sri' }
]

const ROLES = ['pic', 'to', 'cc', 'bcc', 'director']

export default {
  name: 'ContactCards',
  components: { SelectInput, TextInput, PhoneInput, EmailInput },
  props: {
    value: { type: Array, default: () => [] },
    minCards: { type: Number, default: 0 },
    labelOptions: { type: Array, default: () => LABEL_OPTIONS },
    titleOptions: { type: Array, default: () => TITLE_OPTIONS },
    cardErrors: { type: Array, default: () => [] }
  },
  data () {
    return {
      ROLES,
      localCards: [],
      syncing: false
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (val) {
        const incoming = JSON.stringify(val || [])
        if (incoming !== JSON.stringify(this.localCards)) {
          this.syncing = true
          this.localCards = JSON.parse(incoming)
          this.$nextTick(() => { this.syncing = false })
        }
      }
    },
    localCards: {
      deep: true,
      handler (val) {
        if (!this.syncing) {
          this.$emit('input', JSON.parse(JSON.stringify(val)))
        }
      }
    }
  },
  methods: {
    addCard () {
      this.localCards.push({ label: '', title: '', name: '', phone: '', email: '', roles: [] })
    },
    removeCard (idx) {
      this.localCards.splice(idx, 1)
    },
    toggleRole (cardIdx, role) {
      const card = this.localCards[cardIdx]
      if (role === 'pic') {
        this.localCards.forEach((c, i) => {
          if (i !== cardIdx) {
            const pos = c.roles.indexOf('pic')
            if (pos > -1) c.roles.splice(pos, 1)
          }
        })
      }
      const pos = card.roles.indexOf(role)
      if (pos > -1) card.roles.splice(pos, 1)
      else card.roles.push(role)
    }
  }
}
</script>

<style scoped>
.ap-contact-add-wrapper {
  margin-top: 8px;
}

.ap-contact-add-btn {
  width: 100%;
  background: #f8fafc;
  border: 1px dashed #9ca3af;
  color: #64748b;
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
}

.ap-contact-add-btn:hover {
  border-color: #b8860b;
  color: #b8860b;
  background: #fdf8ee;
}
</style>
